
import loadExternalScript from '@Shared/Common/Scripts/Util/_loadExternalScript.js';
export default {
  data: function data() {
    return {
      config: {}
    };
  },
  methods: {
    init: function init(config) {
      this.config = config || {};

      if (this.config.scriptContent && this.config.scriptReferenceId) {
        if (this.config.onLoadScript) {
          var callbackFn = new Function(this.config.onLoadScript);
          loadExternalScript(this.config.scriptContent, this.config.scriptReferenceId, callbackFn);
        } else {
          loadExternalScript(this.config.scriptContent, this.config.scriptReferenceId);
        }
      }
    }
  }
};